import { WebglObject } from "./webgl-object";
import { NamedObjectContainer } from "../named-object-container";

export class GraphicPanel extends WebglObject {
  constructor(settings) {
    super(settings);
    this.items = new NamedObjectContainer("Items"); // drawable objects
    this.settings.debug.boxFillColor = [0, 0.5, 1, 1];
    this.settings.debug.boxStrokeColor = [1, 0, 0.5, 1];
  }

  addItem(item) {
    this.items.add(item);
  }

  createBorders() {
    super.createBorders();
    this.items.forEach(item => {
      item.setParentSize(this.settings.sizeInPixels.width, this.settings.sizeInPixels.height);
      item.createBorders();
    });
  }

  setDebugMode(debugSettings) {
    super.setDebugMode(debugSettings);
    this.items.forEach(item => item.setDebugMode(debugSettings));
  }

  draw(gl, program) {
    super.draw(gl, program);
    this.items.recursiveExecute("draw", gl, program);
  }
}
